import { NumericInput } from './form-controls.jsx';
import { Dialog } from '../../../../components/Dialog';
import { useLpkRunContext } from './lpk-run-context.jsx';

export function OtherProductDialog({ product, nutrient, label, onClose }) {
  const { getParam } = useLpkRunContext();

  return (
    <Dialog
      width="sm"
      title={`${product}`}
      onCancel={onClose}
      canSave={Boolean(getParam(`${nutrient}.percentage`))}
      onSave={onClose}
    >
      <NumericInput
        min={1}
        max={100}
        required
        autoFocus
        name={`${nutrient}.percentage`}
        label={
          label === 'P'
            ? `Enter Value as a Percentage (P₂O₅)`
            : `Enter Value as a Percentage (K₂O)`
        }
      />
    </Dialog>
  );
}
